import { TrixEditor } from "@circle-react-shared/TrixEditor";
import type {
  TrixEditorProps,
  TrixEditorRefObject,
} from "@circle-react-shared/TrixEditor";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";

import {
  legacyClassNames,
  anchorClassNames,
} from "@/react/helpers/cssAnchorHelpers";

/** @deprecated Please use TipTap editor instead for new components */
export const RichTextInput = forwardRef<TrixEditorRefObject, TrixEditorProps>(
  (props, ref) => {
    const { name, className = "", textboxClassName = "" } = props;
    const { control } = useFormContext();

    return (
      <div
        className={classNames(
          anchorClassNames("trix-v2"),
          legacyClassNames("react-rich-text-input"),
          className,
        )}
      >
        <Controller
          control={control}
          name={name}
          render={({ field: { onChange, value } }) => (
            <TrixEditor
              {...props}
              className={textboxClassName}
              onChange={(event: any) => onChange(event.target.innerHTML)}
              value={value}
              ref={ref}
            />
          )}
        />
      </div>
    );
  },
);
RichTextInput.displayName = "RichTextInputControlledInput";
